import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ffb8e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding" }
const _hoisted_2 = { class: "onboarding__modal" }
const _hoisted_3 = { class: "onboarding__pagination" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
        class: "btn btn--exit"
      }),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("button", {
            tabindex: "3",
            key: index,
            onClick: ($event: any) => (_ctx.$emit('stepChanged', step)),
            class: _normalizeClass(['btn btn--step', { selected: _ctx.currentStep === step }])
          }, null, 10, _hoisted_4))
        }), 128))
      ]),
      _withDirectives(_createElementVNode("button", {
        tabindex: "1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('previousStep'))),
        class: "btn btn--previous"
      }, null, 512), [
        [_vShow, _ctx.currentStep > 1]
      ]),
      _withDirectives(_createElementVNode("button", {
        tabindex: "4",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('nextStep'))),
        class: "btn btn--next"
      }, null, 512), [
        [_vShow, _ctx.currentStep < _ctx.steps + 1]
      ])
    ])
  ]))
}